<script>

import GameCardWithLink from '@/launcher/components/shared/GameCardWithLink';
import StationTagRow from '@/launcher/components/shared/StationTagRow.vue';
import GamesGrid from '../shared/GamesGrid';
import { Slider } from 'vue-sliderx';
import { chunk } from 'lodash-es';

export default {
  name: 'GamesByTagsBox',
  props: {
    stationTags: { required: true },
    loading: { },
    error: { },
  },
  components: {
    GameCardWithLink,
    StationTagRow,
    GamesGrid,
    Slider,
  },
  computed: {
    sliderOptions () {
      const stationTagsOpts = {
        clone: false,
        loop: false,
        navigationIncrement: 3,
        perPage: 3,
      };
      const gridOpts = {
        clone: false,
        loop: false,
        navigationIncrement: 1,
        perPage: 1,
      };
      return this.shouldDisplayGrid ? gridOpts : stationTagsOpts;
    },
    shouldDisplayGrid () {
      return !this.loading && this.stationTags.length === 1 && !this.isEmpty && !this.stationTags[0].text;
    },
    gamesToDisplay () {
      return this.shouldDisplayGrid && chunk(this.stationTags[0].games, 16);
    },
    stationTagsToDisplay () {
      return this.loading ? 3 : this.stationTags;
    },
    isEmpty () {
      return !this.loading && (!this.stationTags.length || this.stationTags.every(({ games }) => !games.length));
    },
  },
};
</script>

<template lang="pug">
div.games-tags-box.bg-black-overlay.relative.h-100._collision.pt3
  div.flex.items-center.justify-center.h-100.pb3(v-if="error")
    div.tc.white
      icon.w3.mb4.center.db.fill-white.o-20(name="warning")
      h4.fw7.ttu.f6.mb3 {{ $t('We are having trouble loading games.') }}
      h6.f6 {{ $t('Please contact support if it keeps persisting') }}
  div.emptymsg.flex.items-center.justify-center.h-100.pb3(v-else-if="isEmpty")
    div.tc.white
      icon.w3.mb4.center.db.fill-white.o-20(name="no-results")
      h4.fw7.ttu.f6.mb3 {{ $t('No games to show') }}
      h6.f6 {{ $t('When games are added to this station, they will appear here.') }}
  template(v-else)
    Slider.slider.flex.flex-column.h-100.pb4.pt2(v-bind="sliderOptions", :key="loading")
      arrow-button.prevbtn.center.db.absolute.top-0.left-50.z-1(slot="prev", slot-scope="{ canPrev, prev, index }", @click="prev", :style="{visibility: canPrev && index > 0 ? 'visible': 'hidden'}")
      template(v-if="shouldDisplayGrid")
        div.row.h-100(v-for="(games, i) in gamesToDisplay", :key="i")
          GamesGrid.gamesrow.h-100.ph4.pv3(:games="games")
      template(v-else)
        div.row.h-100(v-for="(stationTag, i) in stationTagsToDisplay", :key="stationTag.id || i")
          StationTagRow.gamesrow.h-100(:loading="loading", :stationTag="stationTag")
      arrow-button.nextbtn.center.db.absolute.bottom-0.left-50.z-1.translate-x--50(slot="next", slot-scope="{ canNext, next }", @click="next", :style="{visibility: canNext ? 'visible': 'hidden'}")
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.games-tags-box {
}
</style>
<style>
.games-tags-box {
  & .slider {
    position: static !important;
    & .prevbtn {
      transform: rotate(180deg) translateX(50%);
    }
    & .viewport {
      /* mask-image: linear-gradient(to bottom, transparent 0%,transparent 5%, black 13%, black 88%, transparent 95%, transparent 100%);  */
      /*NOTE HACK POLYFILL*/
    }
  }
}
</style>
